// 根据距离计算运费的函数
const calculateShippingFeeFromDistance = (distanceKm: number, shipType?: string): number => {
  let fee = 0;
  if (distanceKm <= 20) fee = 118;
  else if (distanceKm <= 40) fee = 148;
  else if (distanceKm <= 70) fee = 168;
  else if (distanceKm <= 100) fee = 228;
  else fee = 298;

  // 如果是双程，费用翻倍
  if (shipType === 'twoway') fee = fee * 2;

  return fee;
};

// Firebase Cloud Function 距离计算服务
export const calculateShippingDistance = async (
  postalCode: string,
  shipType?: string,
): Promise<{ distance: number; fee: number }> => {
  try {
    // 验证postal code格式 (6位字符)
    if (!postalCode || postalCode.length !== 6) {
      throw new Error('Postal code must be exactly 6 characters');
    }

    const COMPANY_POSTAL = 'M1V 4T1'; // 公司地址
    // 使用新的 googleDistanceV2 Cloud Function
    const functionUrl = `https://us-central1-gh-home-bf859.cloudfunctions.net/googleDistanceV2?origin=${COMPANY_POSTAL}&destination=${postalCode.toUpperCase()}`;

    console.log('Calling googleDistanceV2 function with URL:', functionUrl);

    const response = await fetch(functionUrl);

    console.log('Response status:', response.status);
    console.log('Response ok:', response.ok);

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Error response:', errorText);
      throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
    }

    const responseData = await response.json();
    console.log('Response data:', responseData);

    // 检查是否有错误响应
    if (!responseData.success && responseData.error) {
      throw new Error(responseData.error);
    }

    // 处理Google Distance Matrix API响应
    if (
      responseData.rows &&
      responseData.rows[0] &&
      responseData.rows[0].elements &&
      responseData.rows[0].elements[0].status === 'OK'
    ) {
      // 距离（米）
      const distanceInMeters = responseData.rows[0].elements[0].distance.value;
      const distanceKm = Math.round(distanceInMeters / 1000); // 转换为公里

      // 计算运费
      const fee = calculateShippingFeeFromDistance(distanceKm, shipType);

      console.log(`Distance: ${distanceKm}km, Fee: $${fee}`);

      return {
        distance: distanceKm,
        fee: fee,
      };
    } else {
      // 处理各种错误情况
      if (responseData.status === 'REQUEST_DENIED') {
        if (responseData.error_message && responseData.error_message.includes('Billing')) {
          throw new Error('Google Maps billing is not enabled. Please contact administrator.');
        } else {
          throw new Error(
            `Google Maps API error: ${responseData.error_message || 'Request denied'}`,
          );
        }
      } else if (
        responseData.rows &&
        responseData.rows[0] &&
        responseData.rows[0].elements &&
        responseData.rows[0].elements[0]
      ) {
        const elementStatus = responseData.rows[0].elements[0].status;
        throw new Error(`Distance calculation failed: ${elementStatus}`);
      } else {
        throw new Error(`No route found or invalid response: ${JSON.stringify(responseData)}`);
      }
    }
  } catch (error) {
    console.error('Distance calculation error:', error);
    throw error;
  }
};

// 兼容旧版本的函数（保持向后兼容）
export const getDistanceFromGoogle = async (userPostal: string): Promise<number | null> => {
  try {
    const result = await calculateShippingDistance(userPostal);
    return result.distance * 1000; // 返回米为单位，保持与旧版本兼容
  } catch (error) {
    console.error('Legacy distance calculation error:', error);
    return null;
  }
};
